import { getCookie, setCookie } from "./CookieJar";

export const FIRST_TOUCH_COOKIE = "first_touch";

const ONE_YEAR_IN_DAYS = 365;

type FirstTouch = {
    at: string;
    ua: string;
};

// The first visit is usually a marketing page on the apex domain that never reaches
// Laravel, so it is recorded here and read back by registration from the shared cookie.
export function captureFirstTouch() {
    if (getCookie<FirstTouch | null>(FIRST_TOUCH_COOKIE, null) !== null) {
        return;
    }

    setCookie<FirstTouch>(
        FIRST_TOUCH_COOKIE,
        { at: new Date().toISOString(), ua: navigator.userAgent },
        ONE_YEAR_IN_DAYS,
    );
}

export function recordInitiateCheckout() {
    void window.axios.post(route("activation-signals.initiate-checkout"));
}
